import React from 'react'
import RoomStatusSnapshots from './RoomStatusSnapshots'

function RoomStatusHistory() {
    const selectedLoginData = JSON.parse(localStorage.getItem('selectedLoginData')) || {}

    return (
        <RoomStatusSnapshots properties_id={selectedLoginData?.properties_id} />

    )
}

export default RoomStatusHistory